'use strict'
var popularposts = angular.module('popularpostsModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap'
]);
require('./popularposts/js/directive/popularpostsDirective.js')(popularposts);
require('./popularposts/js/popularpostsController.js')(popularposts);




//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/popularpostsModule/popularpostsModule.js
// module id = 545
// module chunks = 0